<template>
  <div class="introduction">
      <div
        class="introduction_box"
        v-for="(items, indexs) in resumeList"
        :key="indexs"
      >
        <p class="blue box_title">{{items.title}}</p>
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(activity, index) in items.activities"
            :key="index"
            color="#1181ff"
            icon="el-icon-help"
            class="introduction_reverse"
          >
            <p class="introduction_titleP">
              {{ activity.title }}
            </p>
            <p class="introduction_timeP">{{ activity.timestamp }}</p>
            <p class="introduction_conP">
              {{ activity.content }}
            </p>
          </el-timeline-item>
            <div v-if="items.activities.length==0" style="text-align:center;margin-bottom:20px" >
                <img src="../../assets/暂无内容.jpg" alt="" style="width:100px">
            </div>
        </el-timeline>
      </div>

  </div>
</template>

<script>
  import { designerDetail } from "../../utils/interface";
export default {
  //   设计师简介
  name: "designIntroduction",
  components: {},
  data() {
    return {
      reverse: true,

      resumeList: [
        {
          title: "工作经历",
          activities: [
          ],
        },
        {
          title: "教育经历",
          activities: [
          ],
        },
        {
          title: "获奖经历",
          activities: [
          ],
        },
      ],
    };
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    getDetailInfo(){
      designerDetail(this.$route.params.uuid).then((res) => {
        console.log(JSON.stringify(res));
        if(res != null){
          if(res.designerDetailList != null && res.designerDetailList.length > 0){
            res.designerDetailList.forEach((item, index) => {
              if(item.detailType == 'WORK'){
                this.resumeList[0].activities.push({title : item.companyName, timestamp : item.dutyTime, content : item.workDesc});
              }else if(item.detailType == 'EDU'){
                this.resumeList[1].activities.push({title : item.schoolName, timestamp : item.schoolTime, content : item.major});
              }else if(item.detailType == 'AWARD'){
                this.resumeList[2].activities.push({title : item.awardName, timestamp : item.awardTime});
              }
            });
          }
        }

      });

    },},
};
</script>

<style scoped lang="less">
.blue {
  color: #1181ff;
}
/deep/.el-timeline-item__tail {
  border-left: 2px solid #1181ff;
}
/deep/.el-timeline .el-timeline-item:last-child .el-timeline-item__tail{
  display: block;
}
/deep/.el-timeline-item:nth-last-child(1){
  padding-bottom: 0;
}
.introduction {
  margin-top: 20px;
  background: #fff;
  border-radius: 10px;
  padding: 20px 15px;
  .introduction_box:nth-last-child(1){
    margin-bottom: 0;
  }
  .introduction_box {
    margin-bottom: 40px;
    .box_title {
      font-size: 16px;
      margin-bottom: 15px;
    }
    .introduction_reverse {
      .introduction_titleP {
        font-size: 14px;
      }
      .introduction_timeP {
        font-size: 14px;
        color: #999;
        margin-bottom: 10px;
        margin-top: 20px;
      }
      .introduction_conP {
        color: #777;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/designIntroduction.vue